<h3>{{NameDescription}}
</h3>
<div class="row">
  <div class="col"> Open Prepays
  </div>
  <div class="col" align="right">Total: {{prepays?prepays.length:0}}
  </div>
</div>
<div align="center" *ngIf="Error">
  {{Error}}
</div>
<mat-dialog-content class="mat-typography" style="padding: 10px">
  <p *ngFor="let prepay of prepays">
    <mat-card appearance="outlined">
      <div class="row">
        <div class="col">
          <strong> {{ prepay.ItemNumber }}             
          </strong>
        </div>
      </div>
      <div class="row">
        <div class="col">
          Rcpt: {{prepay.ReceiptNumber}}
        </div>
        <div class="col" align="right">
          Ck#: {{prepay.CheckNumber}}
        </div>
      </div>
      <div class="row">
        <div class="col">
          {{prepay.PaymentDate | date:'MM/dd/yyyy'}}
        </div>
        <div class="col" align="right">
          {{prepay.PrepaymentQuantity}} {{prepay.QuantityUOM}}
        </div>
      </div>
      <div class="row">
        <div class="col">
          <span><i class="fa fa-map-marker color_green" aria-hidden="true"></i>
            {{prepay.ReceiptLocation}}</span>
        </div>
        <div class="col" align="right">
          {{prepay.TransactionAmount | currency}}
        </div>
      </div>
    </mat-card>
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="ta-openprepay-close text-white magin_5 btn btn-success" [mat-dialog-close]="true">Close</button>
</mat-dialog-actions>